<template>
  <div id="app">
    <transition name="fade">
      <navPC v-show="!isScroll" class="hidden-sm-and-down"></navPC>
    </transition>
    <transition name="fade">
      <navPhone v-show="!isScroll" class="hidden-md-and-up"></navPhone>
    </transition>
    
    <router-view></router-view>
    <to-top></to-top>
  </div>
</template>

<script>
// import navPC from './components/navPC.vue'
import navPC from './components/navPC_09m.vue'

import navPhone from './components/navPhone.vue'
import toTop from "@/components/toTop.vue";
export default {
  name: 'app',
  components: {
    navPC,toTop,navPhone
  },
  data() {
    return {
      isScroll:false,
      lastScroll:null
    }
  },
  methods:{
    NavPCisShow(){
        let nowScoll =  document.documentElement.scrollTop
        if(!this.lastScroll){
          this.lastScroll = nowScoll
        }
       if (nowScoll < 0 || this.lastScroll-nowScoll<0) {            
            this.isScroll = true
        } else {
             this.isScroll = false
        }
        this.lastScroll = nowScoll
    }
  },
  mounted(){
    window.addEventListener("scroll", this.NavPCisShow);
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif,'PingFangSC-Regular', sans-serif,"微软雅黑"; */
  font-family: "Microsoft YaHei UI";
  font-family: "PingFangSC-Regular";
  
  /* -webkit-font-smoothing: antialiased; */
  /* -moz-osx-font-smoothing: grayscale; */
  /* min-height: 200vh; */
  overflow-x: hidden; 
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
